import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePlatformAuth } from "./PlatformAuthContext";

/** Client-side route guard for the platform-operator realm — same UX-only caveat every
 * other app's route guard in this monorepo carries (there's no backend to independently
 * enforce this yet, since no real platform-auth realm exists — see ARCHITECTURE.md). */
export function RequirePlatformAuth({ children }: { children: ReactNode }) {
  const { status } = usePlatformAuth();
  if (status === "unauthenticated") return <Navigate to="/login" replace />;
  if (status === "awaiting-mfa") return <Navigate to="/mfa" replace />;
  return <>{children}</>;
}
